import React from 'react';
import { Button } from '../../components/ui/button';

export const ResetPasswordModal = ({
  open,
  user,
  newPassword,
  onChangePassword,
  onConfirm,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4" data-testid="admin-reset-modal">
        <h2 className="text-2xl font-bold mb-4">Reset Password</h2>
        <p className="text-gray-600 mb-4">
          Reset password for {user?.email}
        </p>
        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(e) => onChangePassword(e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-[#6FBF73]"
          data-testid="admin-reset-password-input"
        />
        <div className="flex gap-4">
          <Button
            onClick={onConfirm}
            className="flex-1 bg-[#4A7C59] hover:bg-[#3D6A4A] text-white"
            data-testid="admin-reset-password-confirm"
          >
            Reset Password
          </Button>
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
            data-testid="admin-reset-password-cancel"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
